import React from "react";
import Merchant from "../modules/Merchant/Merchant";

export default function MerchantPage() {
  return <Merchant />;
}
